import { request } from './client.js';
import type { ClientTenant, OutreachSettingsUpdate } from './types.js';

/** manage_client: the Client's outreach settings (Story 35). Partial updates; returns the Client. */
export function updateOutreachSettings(
  clientTenantId: string,
  body: OutreachSettingsUpdate,
  idToken: string,
): Promise<ClientTenant> {
  return request<ClientTenant>(
    'PUT',
    `/tenants/${encodeURIComponent(clientTenantId)}/outreach-settings`,
    idToken,
    { body },
  );
}

/** manage_client: Slack's authorize URL for the Client's workspace, with a one-time state (task 139c). 409 `slack_not_configured` until the app exists. */
export function startSlackInstall(
  clientTenantId: string,
  idToken: string,
): Promise<{ install_url: string }> {
  return request<{ install_url: string }>(
    'POST',
    `/tenants/${encodeURIComponent(clientTenantId)}/outreach/slack/install`,
    idToken,
  );
}
